import { call, put, takeEvery } from '@redux-saga/core/effects';
import { createAction, handleActions } from 'redux-actions';
import { defaultGridData } from '../../../module/component/TableBoxModule';
import { PATH_DELIMITER, SEMESTER_STUDENT_UNIVERSITY_PATH, ROLE } from '../../../constant/Constant';
import { request } from '../../ApiModule';
import NullCheckUtil from '../../../util/NullCheckUtil';
import { SET_GRID_DATA } from '../../component/TableBoxModule';

const INIT = SEMESTER_STUDENT_UNIVERSITY_PATH + PATH_DELIMITER + 'INIT';
const ACTION_SEARCH = SEMESTER_STUDENT_UNIVERSITY_PATH + PATH_DELIMITER + 'ACTION_SEARCH';
const ACTION_EDIT_USER_REG_VALID_STATUS_CD =
    SEMESTER_STUDENT_UNIVERSITY_PATH + PATH_DELIMITER + 'ACTION_EDIT_USER_REG_VALID_STATUS_CD';
const ACTION_REMOVE = SEMESTER_STUDENT_UNIVERSITY_PATH + PATH_DELIMITER + 'ACTION_REMOVE';
const ACTION_EXCEL_DOWNLOAD = SEMESTER_STUDENT_UNIVERSITY_PATH + PATH_DELIMITER + 'ACTION_EXCEL_DOWNLOAD';
const HANDLE_GRID_DATA = SEMESTER_STUDENT_UNIVERSITY_PATH + PATH_DELIMITER + 'HANDLE_GRID_DATA';
const ACTION_SEARCH_SEMESTER = SEMESTER_STUDENT_UNIVERSITY_PATH + 'ACTION_SEARCH_SEMESTER';

export const actionInit = createAction(INIT);
export const actionSearch = createAction(ACTION_SEARCH);
export const actionEditUserRegValidStatusCd = createAction(ACTION_EDIT_USER_REG_VALID_STATUS_CD);
export const actionRemove = createAction(ACTION_REMOVE);
export const actionExcelDownload = createAction(ACTION_EXCEL_DOWNLOAD);
export const actionSearchSemester = createAction(ACTION_SEARCH_SEMESTER);

export function* semesterStudentUniversitySagas() {
    yield takeEvery(ACTION_SEARCH, actionSearchSaga);
    yield takeEvery(ACTION_EDIT_USER_REG_VALID_STATUS_CD, actionEditUserRegValidStatusCdSaga);
    yield takeEvery(ACTION_REMOVE, actionRemoveSaga);
    yield takeEvery(ACTION_EXCEL_DOWNLOAD, actionExcelDownloadSaga);
    yield takeEvery(ACTION_SEARCH_SEMESTER, actionSearchSemesterSaga);
}

function* actionSearchSaga({ payload: { params, callback } }) {
    const result = yield call(request, {
        method: 'get',
        url: '/api/users',
        params: { ...params, userRoleCd: ROLE.STUDENT },
        callback,
    });

    if (NullCheckUtil.isNotEmpty(result)) {
        yield put({
            type: SET_GRID_DATA,
            payload: {
                ...result,
            },
        });
    }
}

function* actionSearchSemesterSaga({ payload: { userId, callback } }) {
    yield call(request, {
        method: 'get',
        url: `/api/users/${userId}/regSemesterSearch`,
        params: { userId },
        callback,
    });
}

function* actionEditUserRegValidStatusCdSaga({ payload: { data, callback } }) {
    yield call(request, {
        method: 'put',
        url: `/api/users/${data.userId}/staff-confirm`,
        data,
        callback,
    });
}

function* actionRemoveSaga({ payload: { data, callback } }) {
    yield call(request, {
        method: 'delete',
        url: `/api/users/${data.userId}`,
        params: { ...data },
        callback,
    });
}

function* actionExcelDownloadSaga({ payload: { params } }) {
    yield call(request, {
        method: 'get',
        url: `/api/users/student-excel-export`,
        params: { ...params, userRoleCd: ROLE.STUDENT },
        download: true,
        downloadDirect: true,
        downloadType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
}

const initialState = {
    gridData: defaultGridData,
    regSemesterList: [],
};

const module = handleActions(
    {
        [INIT]: () => initialState,
        [HANDLE_GRID_DATA]: (state, { payload: result }) => ({ ...state, result }),
    },
    initialState,
);

export default module;
